/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useEffect, useRef} from "react";
import Objects from "toolbox/objects";

function useCompareEffect(callback, dependencies) {
    const previousDepsRef = useRef([]);

    const dependenciesChanged = dependencies.some((dep, index) => {
        return !Objects.areEqual(dep, previousDepsRef.current[index]);
    });

    useEffect(() => {
        if (dependenciesChanged) {
            callback();
            previousDepsRef.current = dependencies;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dependenciesChanged]);
}

export default useCompareEffect;